import { getComparePageBySlug } from "@/app/seo-compare";
import { CompareLayout } from "./CompareLayout";

export default function HotlineVsSaas() {
  const page = getComparePageBySlug("hotline-vs-saas");
  if (!page) return null;
  return <CompareLayout page={page} />;
}
